import { render } from "./ConsultarSaldoView.vue?vue&type=template&id=55b529fc"
import script from "./ConsultarSaldoView.vue?vue&type=script&lang=js"
export * from "./ConsultarSaldoView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__